import moment from 'moment'
import { useEffect, useState } from 'react'
import { StateCase } from '../../config/enums'
import { getCompanySelected } from '../../utilities/controlStorage'
import { controlList } from './storage'

export default function useInitial() {
    const [state, setState] = useState(StateCase.LOADING)

    useEffect(() => {
        load().then(pageState => setState(pageState))
    }, [])

    async function load() {
        const company = getCompanySelected()

        controlList.filter.setOption('company_id', {
            value: company.id.toString(),
            label: company.name,
            image: company.country.image_url
        })

        const endDate = moment().format('YYYY-MM-DD')
        const startDate = moment().subtract(1, 'year').format('YYYY-MM-DD')

        controlList.filter.setParams('start_date', startDate)
        controlList.filter.setParams('end_date', endDate)

        return StateCase.SUCCESS
    }

    return { state }
}
